export const FIXED_DT = 1 / 50
export const MAX_STEPS_PER_FRAME = 8

export interface StepPlan {
  /** quanti passi di fisica eseguire in questo frame */
  readonly steps: number
  /** tempo residuo da riportare al frame successivo */
  readonly accumulator: number
  /** frazione di passo residua, per interpolare il rendering */
  readonly alpha: number
}

/**
 * Accumulatore a passo fisso.
 *
 * Il tetto su `steps` non e un dettaglio: senza, una finestra rimasta in
 * background per mezzo minuto tornerebbe in primo piano con 1500 passi da
 * eseguire in un frame, che ne richiederebbero altri, e il gioco si
 * pianterebbe per sempre. Il tempo in eccesso si butta: meglio saltare mezzo
 * minuto di simulazione che non tornare mai piu.
 */
export function planSteps(
  accumulator: number, frameSeconds: number, fixedDt: number, maxSteps: number,
): StepPlan {
  const delta = Number.isFinite(frameSeconds) && frameSeconds > 0 ? frameSeconds : 0
  let acc = accumulator + delta

  const steps = Math.floor(acc / fixedDt)
  if (steps > maxSteps) return { steps: maxSteps, accumulator: 0, alpha: 0 }

  acc -= steps * fixedDt
  return { steps, accumulator: acc, alpha: acc / fixedDt }
}
